<div class="page status-page">
  <div class="status-card success">
    <img src="/assets/icons/circle-check-thin.svg" alt="success" class="flex w-[108px] h-[108px] m-auto mb-10">
    <h1>感謝您註冊賬戶</h1>
    <p>我們已發送一封電子郵件至 <strong>{{ email }}</strong>，請點擊郵件內的連結進行賬戶驗證。</p>
    <p *ngIf="project == 'hklsc_pthyxs'">驗證完成後，您的申請將由管理員儘快審核。</p>
    <a routerLink="/">重新提交報名</a>
  </div>
</div>
